import React, { useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import { useHashtagCountryDistribution } from '@opm/pages/Hashtag/hooks';
import DistributionProgress from '../DistributionProgress';
import useIntls from '@opm/hooks/useIntls';
import HashtagMapChart from '../HashtagMapChart';
import BubbleCommon from '@op/components/BubbleCommon';
import { countryList } from '@opm/components/FilterCommon/constants/country';
import { hashtagCountryDistributionTop5DetailTipsMap } from '@opm/components/BubbleCommon';

export default function HashtagCountryDistribution(props: { filter: any }) {
  const { filter } = props;
  const { intl } = useIntls();

  const filterParams = useMemo(
    () => ({
      ...filter,
      countries: [],
    }),
    [filter],
  );

  const { loading, data } = useHashtagCountryDistribution({
    filter: filterParams,
  });

  return (
    <CardCommon
      loading={loading}
      title={
        <div className="dbom-hashtag-country-distribution-title-container">
          <BubbleCommon
            placement='left'
            tipsMap={hashtagCountryDistributionTop5DetailTipsMap(countryList)}
          >
            <span className="dbom-hashtag-country-distribution-title">
              {intl('Country Distribution')}
            </span>
          </BubbleCommon>
          <span className="dbom-hashtag-country-distribution-subtitle">
            {intl(
              'Country data is only included if the hashtag is in its Top 100 within the selected time',
            )}
          </span>
        </div>
      }
      className="dbom-hashtag-country-distribution"
      loadingHeight={620}
    >
      <DistributionProgress
        data={data}
        valueKey={'tweets_views'}
        title={'Views (Top 5)'}
        contentCard
      />
      <DistributionProgress
        data={data}
        valueKey={'tweets_posts'}
        title={'Videos (Top 5)'}
        contentCard
      />
      <HashtagMapChart data={data?.filter((val: { country: string; }) => val.country !== 'all') || []} />
    </CardCommon>
  );
}
